module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12"
  }, [_c('div', {
    staticClass: "font-size-24 blue-grey-700 m-b-5"
  }, [_vm._v("Team name : " + _vm._s(_vm.team.name) + "\n              "), (_vm.team.is_reseller) ? _c('span', {
    staticClass: "font-size-18 red-600"
  }, [_vm._v("[ Reseller ]")]) : (_vm.team.has_reseller) ? _c('span', {
    staticClass: "font-size-18 blue-600"
  }, [_vm._v("[ Sub Team ]")]) : _c('span', {
    staticClass: "font-size-18 grey-600"
  }, [_vm._v("[ Normal ]")])]), _vm._v(" "), (_vm.team.has_reseller) ? _c('div', {
    staticClass: "font-size-14"
  }, [_vm._v("Reseller : " + _vm._s(_vm.team.reseller ? _vm.team.reseller.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "font-size-14"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-12"
  }, [_c('div', {
    staticClass: "counter counter-lg text-xs-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (_vm.team.namespace) + "/edit"),
      "alt": "Edit Team"
    }
  }, [_c('i', {
    staticClass: "icon md-edit",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22bae63f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/TeamInfo.vue
// module id = 515
// module chunks = 1